<template>
  <div class="shop-container">
    <ph-header>
      <van-icon name="arrow-left" size="20px" slot="left" @click="$router.back(-1)" />
    </ph-header>
    <coupon-list v-if="!isEmpty" ctype="0" :list.sync="list" @toPay="goPay"></coupon-list>
    <empty-coupon v-if="isEmpty"></empty-coupon>
    <div style="display: block;height: 1rem;"></div>
    <button class="footer-btn" @click="noPrivilege">不使用优惠券</button>
  </div>
</template>

<script>
import { getCouponList } from '@/api/user'
import CouponList from '@/components/business/CouponList'
import EmptyCoupon from '@/components/business/EmptyCoupon'
import PhHeader from '@/components/common/Header'

export default {
  components: {
    PhHeader,
    CouponList,
    EmptyCoupon
  },
  data () {
    return {
      list: [],
      isEmpty: false,
      goodsid: '0',
      return_url: ''
    }
  },
  created () {
    this.goodsid = this.$route.query.gids || '0'
    this.return_url = this.$route.query.return_url
    this.getData()
  },
  methods: {
    // 获取数据
    getData () {
      let _gids = []
      if (this.goodsid != '0') {
        _gids = this.goodsid.split(',')
      }
      var data = {
        scopeOfUse: 1,
        orderCommodityIds: _gids,
        userToken: this.$store.getters.token || ''
      }
      getCouponList(data).then(res => {
        if (res.length == 0) {
          this.isEmpty = true
        } else {
          this.list = res
          this.isEmpty = false
        }
      }).catch(error => {
        console.log(error)
      })
    },
    noPrivilege () {
      this.$store.commit('SET_USER_BALANCE', { couponId: '0', coupon: null, isUse: false })
      location.href = this.return_url
    },
    goPay(i) {
      var cop = this.list[i]
      this.$store.commit('SET_USER_BALANCE', { couponId: cop.privilegeId, coupon: cop, isUse: true })
      location.href = this.return_url
    }
  }
}
</script>

<style lang="less" scoped>
  .van-hairline--top-bottom::after {
    border-width: 0;
  }
  .van-hairline--bottom::after {
    border-bottom-width: 0;
  }
  .footer-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 0;
    background: #FFD133;
    height: 1rem;
    font-size:.32rem;
    font-weight:500;
    color:#282828;
    line-height:.32rem;
    border: 0;
  }
  button::after {
    border: 0;
    border-radius: 0;
  }
</style>
